module.exports = __webpack_public_path__ + "pa.svg?f97d854cff6e47356df02356769f59fc";